<template>
    <div class="batch-live-wrapper">
        <a-modal
            class="batch-live"
            :visible="visible"
            :title="$t('program.batch_live_title' /* 批量设置直播备注 */)"
            :width="600"
            :maskClosable="false"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel"
        >
            <a-form :form="form">
                <a-form-item>
                    <div class="bold" style="color: #f00">
                        {{ $t('program.batch_live_note_warning') }}
                        <!-- 注意：三项都不选择，则更新会议下所有session的直播备注 !!! -->
                    </div>
                </a-form-item>

                <!-- 日期 -->
                <a-form-item :label="$t('program.batch_live_label_date')">
                    <a-select :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_date')" v-decorator="['date_id']">
                        <a-select-option v-for="item in dateList" :key="item.id" :value="item.id">
                            {{ item.meeting_date }}
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <!-- 会场 -->
                <a-form-item :label="$t('program.batch_live_label_hall')">
                    <a-select :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_hall')" v-decorator="['hall_id']">
                        <a-select-option v-for="item in hallList" :key="item.id" :value="item.id">
                            {{ item.meeting_hall }}
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <!-- 专题分论坛 -->
                <a-form-item :label="$t('program.batch_live_label_xuezu')" v-if="xuezuList.length">
                    <a-select :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_xuezu')" v-decorator="['xuezu_id']">
                        <a-select-option v-for="item in xuezuList" :key="item.id" :value="item.id">
                            {{ item.class_cnname }}
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <!-- 直播备注 -->
                <a-form-item :label="$t('program.batch_live_label_live_notes')">
                    <tinymce-editor ref="tinymceEditor" v-decorator="['live_notes']" :type="2"></tinymce-editor>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
import tinymceEditor from '@/components/Tinymce/index.vue';

const fileds = ['date_id', 'hall_id', 'xuezu_id', 'live_notes'];

export default {
    name: 'BatchLiveModal',
    props: {
        xuezuList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        dateList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        hallList: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    components: { tinymceEditor },
    data() {
        return {
            visible: false,
            confirmLoading: false,
            form: this.$form.createForm(this)
        };
    },
    methods: {
        show(id) {
            this.visible = true;
            this.$nextTick(() => {
                this.form.setFieldsValue({ xuezu_id: id || this.xuezuList[0].id });
            });
        },
        handleOk() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.confirmLoading = true;
                    this.$request
                        .post({ url: 'batchLiveRemark', data: values })
                        .then(res => {
                            this.$message.success(res.message);
                            this.confirmLoading = false;
                            this.handleCancel();
                            this.$emit('closeBatchLive');
                        })
                        .finally(() => {
                            this.confirmLoading = false;
                        });
                }
            });
        },
        handleCancel() {
            this.form.resetFields();
            this.visible = false;
        }
    }
};
</script>
<style lang="less" scoped>
::v-deep .ant-form-item {
    margin-bottom: 5px;
}
::v-deep .ant-modal-body {
    max-height: 72vh;
    overflow-y: auto;
}
</style>